import { render, staticRenderFns } from "./Snippets.vue?vue&type=template&id=0533a282&scoped=true"
import script from "./Snippets.vue?vue&type=script&lang=js"
export * from "./Snippets.vue?vue&type=script&lang=js"
import style0 from "./Snippets.vue?vue&type=style&index=0&id=0533a282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533a282",
  null
  
)

export default component.exports